import React from 'react'

import PropTypes from 'prop-types'

import CardMui from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import useStyles from './styles'

const Card = (props) => {
  const {
    headerLeft,
    headerRight,
    headerTitleProps,
    title,
    children,
    className,
    style,
    cardContentProps,
    cardStyle,
    onClick,
    onKeyDown,
    headerStyle,
    noWrapper
  } = props

  const classes = useStyles()

  const card = (
    <CardMui className={ classes.cardContainer } style={ cardStyle }>
      <CardContent { ...cardContentProps } style={ { padding: 0, ...(cardContentProps.style || {}) } }>
        <div className={ classes.header } style={ headerStyle }>
          {headerLeft}
          {title && (
            <Typography
              className={ classes.title }
              variant="body1"
              component="h2"
              { ...headerTitleProps }
              style={ {
                paddingLeft: headerLeft ? 10 : 0,
                ...(headerTitleProps.style || {})
              } }
            >
              {title}
            </Typography>
          )}
          {headerRight}
        </div>
        {children}
      </CardContent>
    </CardMui>
  )

  if (noWrapper) return card

  return (
    <div
      role="button"
      tabIndex="0"
      className={ [classes.container, className].join(' ') }
      style={ { ...style, outline: 'none' } }
      onClick={ onClick }
      onKeyDown={ onKeyDown }
    >
      {card}
    </div>
  )
}

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerTitleProps: PropTypes.object,
  headerLeft: PropTypes.element,
  headerRight: PropTypes.element,
  children: PropTypes.any,
  loading: PropTypes.bool,
  className: PropTypes.string,
  headerStyle: PropTypes.object,
  style: PropTypes.object,
  cardContentProps: PropTypes.object,
  cardStyle: PropTypes.object,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  noWrapper: PropTypes.bool
}

Card.defaultProps = {
  loading: false,
  headerTitleProps: {},
  headerLeft: null,
  headerRight: null,
  title: null,
  cardContentProps: {},
  className: null,
  headerStyle: {},
  style: {},
  cardStyle: {},
  onClick: () => {},
  onKeyDown: () => {},
  children: null,
  noWrapper: false
}

export default Card
